<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">千橙ERP</div>
        <div class="line" />
        <div class="desc">
          面向中小微实体零售门店，帮助门店提效降本增收拓客
        </div>
        <div class="btn-wrap">
          <div
            class="btn1"
            @click="openLoginModal"
          >免费试用</div>
          <div
            class="btn"
            @click="openModal"
          >立即咨询</div>
        </div>
        </div>
    </div>
    <div class="distribution">
      <div class="sk-block-title">
        <div class="title">门店经营痛点</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content1.png" alt="">
          <span class="content_title">进货难</span>
          <ul>
            <li><span>采购渠道少，采购成本高</span></li>
            <li><span>上下游商品未同步，维护成本高</span></li>
          </ul>
          <!-- <div class="line" /> -->
          <!-- <p>招募代理人，不断裂变，通过任务奖励、商品佣金奖励刺激代理人将商品、活动分享到微信朋友圈，微信好友，实现社群传播，实现商品销售</p> -->
        </div>
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content2.png" alt="">
          <span class="content_title">管货弱</span>
          <ul>
            <li><span>商品维护工作量大</span></li>
            <li><span>多规格、多型号商品，管理繁琐</span></li>
            <li><span>多店员管理，实时库存无法共享</span></li>
          </ul>
          <!-- <div class="line" /> -->
          <!-- <p>为门店提供销货通道，通过接入平台商品库，将商品同步给体系内所以的门店，让门店帮你做分销，销售通路广，销量不用愁</p> -->
        </div>
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content3.png" alt="">
          <span class="content_title">销货慢</span>
          <ul>
            <li><span>门店辐射范围有限，客流渐少</span></li>
            <li><span>渠道和手段单一，开单效率低</span></li>
            <li><span>多员工开单无法统一管理</span></li>
          </ul>
          <!-- <div class="line" /> -->
          <!-- <p>提供海量优质商品，让门店不愁没有好货做分销，甚至提供一件代发服务，不囤货也能开店，通过商品吸引更多粉丝进店</p> -->
        </div>
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content4.png" alt="">
          <span class="content_title">盘账乱</span>
          <ul>
            <li><span>账本安全隐私无法保障</span></li>
            <li><span>业务往来频繁，流水杂乱不清晰</span></li>
            <li><span>多种账本，无法体现店铺盈亏</span></li>
          </ul>
          <!-- <div class="line" /> -->
          <!-- <p>提供海量优质商品，让门店不愁没有好货做分销，甚至提供一件代发服务，不囤货也能开店，通过商品吸引更多粉丝进店</p> -->
        </div>
      </div>
    </div>
    <div class="shop">
      <div class="sk-block-title1">
        <div class="title1">优选供应链渠道，商品一键入库</div>
        <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div>
      </div>
      <div class="content">
        <div class="content_left">
            <div class="content_box">
                <div class="content_box_left">
                    <img src="@/assets/images/qcerpsystem/content_box_right1.png" alt="">
                </div>
                <div class="content_box_right">
                    通过汇通达采购商城或接入三方采购商城，方便选货比价
                </div>
            </div>
            <div class="content_box">
                <div class="content_box_left">
                    <img src="@/assets/images/qcerpsystem/content_box_right2.png" alt="">
                </div>
                <div class="content_box_right">
                    整采零售，自动转换销售单位
                </div>
            </div>
            <div class="content_box">
                <div class="content_box_left">
                    <img src="@/assets/images/qcerpsystem/content_box_right3.png" alt="">
                </div>
                <div class="content_box_right">
                    采购商品一键转化为销售商品，免去商品维护成本
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="sharp">
      <!-- <div class="sk-block-title">
        <div class="title">“三大利器”助力开展分享裂变</div>
      </div> -->
      <div class="content">
        <div class="right">
          <div class="sub-title" style="margin-top: 48px;">多类型商品管理，业务高效流转</div>
          <div class="sub-content">多种商品建档方式，且支持多种类型商品管理，帮助店铺高效管理商品资产</div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/qcerpsystem/sharp1.png" alt="">
            </div>
            <div class="content-box-right">
                多种建档方式：扫码入库、采购入库、批量导入、商品库快速通道
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/qcerpsystem/sharp2.png" alt="">
            </div>
            <div class="content-box-right">
              多类型商品管理：串码管理、条码管理、称重商品、多规格商品
            </div>
          </div>
        </div>
        <img src="@/assets/images/qcerpsystem/sharp_bg.png" alt="">
      </div>
    </div>
    <div class="coreFun">
      <!-- <div class="sk-block-title">
        <div class="title">核心功能</div>
      </div> -->
      <div class="content">
        <img class="content_bg" src="@/assets/images/qcerpsystem/coreFun_bg.png" alt="">
        <div class="left" style="margin-left: 69px;">
          <div class="sub-title" style="margin-top: 67px;">全渠道订单聚合管理，多端协同</div>
          <div class="sub-content">全渠道订单协同管理，数据云端化，助力经营提效</div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/qcerpsystem/coreFun1.png" alt="">
            </div>
            <div class="content-box-right">
                多端：自有平台（PC&APP&一体机）+第三方平台（美团、饿了么）
            </div>
          </div>
          <div class="content-box">
            <div class="content-box-left">
              <img src="@/assets/images/qcerpsystem/coreFun2.png" alt="">
            </div>
            <div class="content-box-right">
                多端订单统一管理，数据实时同步
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sharp">
      <!-- <div class="sk-block-title">
        <div class="title">“三大利器”助力开展分享裂变</div>
      </div> -->
      <div class="content">
        <div class="right">
          <div class="sub-title">报表分析，帮助店铺开源节流</div>
          <div class="sub-content">多维业务分析报表与财务报表，深度分析经营状况，辅助制定经营策略</div>
          <div class="content-box" style="margin-top: 50px;">
            <div class="content-box-left">
              <img src="@/assets/images/qcerpsystem/sharp3.png" alt="">
            </div>
            <div class="content-box-right">
                经营分析，通过订单客单价、商品毛利等数据，提升经营效率
            </div>
          </div>
          <div class="content-box" style="margin-top: 50px;">
            <div class="content-box-left">
              <img src="@/assets/images/qcerpsystem/sharp4.png" alt="">
            </div>
            <div class="content-box-right">
                会员分析，通过数据分析会员属性和喜好，帮助筛选多维度会员
            </div>
          </div>
          <div class="content-box" style="margin-top: 50px;">
            <div class="content-box-left">
              <img src="@/assets/images/qcerpsystem/sharp5.png" alt="">
            </div>
            <div class="content-box-right">
                财务分析，清晰记录每笔数据进出，助力店铺盈亏了解
            </div>
          </div>
        </div>
        <img style="width: 695px;height: 512px;" src="@/assets/images/qcerpsystem/sharp_bg2.png" alt="">
      </div>
    </div>
    <div class="scene">
      <div class="sk-block-title1">
        <div class="title1">更多场景功能</div>
        <div class="sub-title1">功能齐全，覆盖店铺经营全场景，为店铺降本增效保驾护航</div>
      </div>
      <div class="content"></div>
    </div>
    <div class="case">
      <div class="sk-block-title1">
        <div class="title1">不同客群差异化服务</div>
      </div>
      <div class="content">
        <img src="@/assets/images/qcerpsystem/case1.png" alt="">
        <img src="@/assets/images/qcerpsystem/case2.png" alt="">
      </div>
    </div>
    <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">客户案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/qcerpsystem/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/qcerpsystem/custom_bg2.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <Contact :infoSources="'汇通数科官网-千橙ERP'"/>
    <TryModal v-if="visible" :visible="visible" info-sources="千橙ERP" @cancel="modalClose" />
    <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'1'"
        />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Contact from '@/components/Contact'
import metaInfo from '@/common/util/metaInfo'
import TryModal from '@/components/TryModal'
import LoginModal from '@/components/LoginModal'

export default {
  metaInfo: metaInfo.QcErpSystem,
  components: {
    Header,
    Footer,
    TryModal,
    Contact,
    LoginModal
  },
  data() {
    return {
      visible: false,
      showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
    }
  },
  mounted() {

  },
  methods: {
    // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ i.el-icon-arrow-left {
    font-size: 35px;
    font-weight: 600;
}
/deep/ i.el-icon-arrow-right{
    font-size: 35px;
    font-weight: 600;
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}
.custom{
    height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:439px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 439px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 439px;
            }
        }
    }
}
.case{
    background: #F8FBFF;
    .content{
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        img{
            width: 602px;
            height: 582px;
        }
    }
}
.content_title{
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
}
.content-center {
    ul,
    li {
    list-style: disc;
    }
  // .banner {
  //   background: url("~@/assets/images/community/community_banner.png") no-repeat center;
  //   min-width: 1200px;
  //   .btn-wrap {
  //     width: 1200px;
  //     margin: 0 auto;
  //     padding: 309px 0 53px;
  //     .btn {
  //       width: 200px;
  //       height: 58px;
  //       line-height: 58px;
  //       border-radius: 6px;
  //       border: 1px solid #FFFFFF;
  //       font-size: 22px;
  //       color: #FFFFFF;
  //       cursor: pointer;
  //     }
  //   }
  // }
  .banner {
    background: url("~@/assets/images/qcerpsystem/qcerpsystem_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 512px;
        height: 101px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
      }
      .btn-wrap {
        display: flex;
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
          margin-left:20px;
        }
        .btn1 {
          width: 200px;
          height: 58px;
          line-height: 58px;
          background: #3986FF;
          border-radius: 6px;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        //   margin-left:20px;
        }
      }
    }
  }
  .distribution {
    background: #F8FCFF;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0 124px 0;
      .item {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        width: 238px;
        height: 370px;
        // background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
        border-radius: 6px;
        // justify-content: center;
        align-items: center;
        padding: 10px 28px;
        background: fixed url("~@/assets/images/qcerpsystem/content_bg.png") no-repeat center;
        background-size: 100% 100%;
        ul{
            margin-top: 20px;
        }
        li {
        list-style: disc;
        text-align: left;
        margin-bottom:10px;
        span{
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 22px;
            }
        }
        img {
          width: 144px;
          height: 144px;
        }
        span {
          margin-top: 12px;
          height: 30px;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 30px;
        }
        div {
          margin-top: 12px;
          width: 40px;
          height: 6px;
          background: #2F81E8;
        }
        p {
          margin-top: 36px;
          width: 293px;
          font-size: 18px;
          font-weight: 400;
          color: #595961;
          line-height: 26px;
          text-align: left;
        }
      }
    }
  }
  .shop {
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    .content {
      width: 1200px;
      height:503px;
      text-align: center;
      margin: 17px 0 51px 0;
      background: url("~@/assets/images/qcerpsystem/shop_bg.png") no-repeat center;
      background-size: 1200px 503px;
      .content_left{
        width: 300px;
        padding: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        float: right;
        .content_box{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 40px;
           .content_box_left{
                width: 24px;
                img{
                    width: 24px;
                    height: 24px;
                }
           }
           .content_box_right{
                width: 200px;
                text-align: left;
                // height: 33px;
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 33px;
           }
        }
     }
    }
  }
  .sub-title {
    font-size: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
    margin-bottom:20px;
      }
      .sub-content {
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 36px;
      }
  .sharp {
    background: #F8FBFF;
    .content {
      width: 1159px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 57px 0 60px 0;
      .right {
        width: 578px;
        text-align: left;
      }
      img{
        width: 628px;
        height: 522px;
      }

    }
  }
  .content-box{
      display: flex;
      flex-direction: row;
      margin-top: 66px;
      .content-box-left{
          width:24px;
          display: flex;
          align-items: center;
          img{
              width: 24px;
              height: 24px;
          }
      }
      .content-box-right{
          width: 383px;
          font-size: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
          margin-left:15px;
      }

  }
  .coreFun {
    padding-bottom: 73px;
    // background: #FAFAFA;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1179px;
      margin: 60px auto 0;
      .left {
        width: 600px;
        text-align: left;
      }
      .content_bg{
        width: 693px;
        height: 473px;
      }

    }
  }
  .scene {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .content {
      width: 1200px;
      height:537px;
      text-align: center;
      margin: 30px 0 51px 0;
      background: url("~@/assets/images/qcerpsystem/scene_bg.png") no-repeat center;
      background-size: 1200px 503px;
    }
  }
}
</style>
